import classNames from 'classnames';
import React, { memo } from 'react';
import { IconProps } from '../types/icon';
import styles from './loading-animation.module.sass';

export const LoadingAnimation = memo(({ className }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(className, styles.loadingAnimation)}
    viewBox="0 0 108 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z"
      fill="#EBEAE9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      opacity="0.454031"
      d="M38.5 15C42.6421 15 46 11.6421 46 7.5C46 3.35786 42.6421 0 38.5 0C34.3579 0 31 3.35786 31 7.5C31 11.6421 34.3579 15 38.5 15Z"
      fill="#EBEAE9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      opacity="0.295233"
      d="M69.5 15C73.6421 15 77 11.6421 77 7.5C77 3.35786 73.6421 0 69.5 0C65.3579 0 62 3.35786 62 7.5C62 11.6421 65.3579 15 69.5 15Z"
      fill="#EBEAE9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      opacity="0.154212"
      d="M100.5 15C104.642 15 108 11.6421 108 7.5C108 3.35786 104.642 0 100.5 0C96.3579 0 93 3.35786 93 7.5C93 11.6421 96.3579 15 100.5 15Z"
      fill="#EBEAE9"
    />
  </svg>
));
